var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTablesSolid = function SvgTablesSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8V7c0-.8-.667-1-1-1H4c-.333 0-1 .2-1 1v1c0 .333.2 1 1 1h16c.8 0 1-.667 1-1Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12h8",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.5V9h3v10.5c0 .8-.667 1-1 1H6c-.8 0-1-.667-1-1ZM16 19.5V9h3v10.5c0 .8-.667 1-1 1h-1c-.8 0-1-.667-1-1Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgTablesSolid;